export enum CarlDataType {
  Configuration = 'config',
  Translations = 'translations'
}
